export const hotTopics = [
  {
    id: '1',
    slug: 'ding-yuxi-bei-bao-shui-jun',
    title: '丁禹兮被曝买水军刷数据，工作室连夜发声明',
    excerpt: '某数据公司内部人员爆出截图，显示知名演员丁禹兮团队长期雇佣水军刷榜。',
    category: '明星塌房',
    categorySlug: 'star-scandal',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20breaking%20news%20concept%20with%20dramatic%20lighting%20and%20silhouette%20of%20a%20person%20behind%20frosted%20glass%2C%20paparazzi%20flash%20effect%2C%20dark%20moody%20atmosphere%2C%20editorial%20magazine%20style%2C%20warm%20deep%20brown%20tones%2C%20minimalist%20composition%2C%20clean%20background%20with%20soft%20bokeh%20lights&width=800&height=600&seq=hot-1-x7q2&orientation=landscape',
    date: '2026-07-05',
    tags: ['丁禹兮', '水军', '数据造假'],
    viewCount: 234567,
    commentCount: 8921,
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    slug: 'wanghong-xiaomei-fancha-shipin',
    title: '网红小美反差视频流出，清纯人设彻底崩塌',
    excerpt: '以清纯形象走红的短视频网红小美被爆出私下反差极大，多段视频引发热议。',
    category: '网红反差',
    categorySlug: 'influencer-drama',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20dramatic%20contrast%20concept%2C%20split%20face%20portrait%20with%20angelic%20and%20dark%20sides%2C%20moody%20lighting%20with%20warm%20coral%20accents%2C%20editorial%20photography%20style%2C%20clean%20minimal%20background%2C%20cinematic%20composition&width=800&height=600&seq=hot-2-k9m4&orientation=landscape',
    date: '2026-07-05',
    tags: ['网红', '反差', '人设崩塌'],
    viewCount: 189234,
    commentCount: 6543,
    isHot: true,
    isNew: true,
  },
  {
    id: '3',
    slug: 'meiri-dasai-diqiqi-jingcai',
    title: '每日大赛第七期：谁能想到她竟然拿了第一',
    excerpt: '本期每日大赛精彩纷呈，黑马选手逆袭夺冠，评委团集体震惊。',
    category: '每日大赛',
    categorySlug: 'daily-competition',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20competition%20stage%20with%20dramatic%20spotlight%2C%20silhouette%20of%20a%20winner%20raising%20hands%2C%20confetti%20falling%2C%20warm%20golden%20and%20amber%20lighting%2C%20editorial%20photography%2C%20clean%20stage%20background%2C%20cinematic%20atmosphere&width=800&height=600&seq=hot-3-p2v8&orientation=landscape',
    date: '2026-07-04',
    tags: ['每日大赛', '黑马', '逆袭'],
    viewCount: 156789,
    commentCount: 4321,
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    slug: 'zhang-mou-dachang-bei-bao-toushui',
    title: '张某大厂被曝偷税漏税，金额高达数千万',
    excerpt: '据知情人士透露，某知名大厂艺人张某涉嫌偷逃税款，已被相关部门约谈。',
    category: '明星塌房',
    categorySlug: 'star-scandal',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tax%20investigation%20concept%20with%20documents%20and%20magnifying%20glass%2C%20dramatic%20shadows%20on%20a%20desk%2C%20warm%20brown%20tones%2C%20editorial%20news%20photography%20style%2C%20clean%20minimal%20background%2C%20professional%20atmosphere&width=800&height=600&seq=hot-4-w5n1&orientation=landscape',
    date: '2026-07-04',
    tags: ['偷税漏税', '大厂艺人', '独家'],
    viewCount: 345678,
    commentCount: 12345,
    isHot: false,
    isNew: true,
  },
];

export const featureArticles = [
  {
    id: '5',
    slug: 'beihou-zhenxiang-ding-yuxi-shiye-chengzhang',
    title: '丁禹兮的崛起之路：从小透明到一线顶流的背后真相',
    excerpt: '深度揭秘丁禹兮如何在短短三年内完成从小透明到一线顶流的华丽转身。',
    category: '独家爆料',
    categorySlug: 'exclusive',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rising%20star%20journey%20concept%20with%20staircase%20made%20of%20light%20going%20upward%2C%20dramatic%20cinematic%20lighting%2C%20warm%20coral%20and%20golden%20accents%2C%20editorial%20magazine%20style%2C%20clean%20minimal%20composition%2C%20inspirational%20mood&width=800&height=1000&seq=feat-1-a3b7&orientation=portrait',
    date: '2026-07-03',
    tags: ['丁禹兮', '深度报道', '娱乐圈'],
    viewCount: 567890,
    commentCount: 23456,
  },
  {
    id: '6',
    slug: 'fancha-wanghong-quanqi',
    title: '反差网红圈内幕：那些你不知道的MCN运作黑幕',
    excerpt: '揭开MCN机构如何批量打造反差网红的神秘面纱，内部运作机制全曝光。',
    category: '网红反差',
    categorySlug: 'influencer-drama',
    imageUrl: 'https://readdy.ai/api/search-image?query=MCN%20agency%20behind%20the%20scenes%20concept%2C%20multiple%20screens%20showing%20social%20media%20feeds%2C%20dramatic%20shadow%20play%2C%20warm%20brown%20and%20amber%20tones%2C%20editorial%20documentary%20style%2C%20clean%20minimal%20background&width=800&height=1000&seq=feat-2-c4d9&orientation=portrait',
    date: '2026-07-02',
    tags: ['MCN', '网红', '内幕'],
    viewCount: 234567,
    commentCount: 8765,
  },
  {
    id: '7',
    slug: 'qunian-jinri-dagua-pan',
    title: '2026上半年娱乐圈十大名场面盘点',
    excerpt: '盘点今年上半年娱乐圈最具话题度的十大名场面，你想不到的都在这里。',
    category: '独家爆料',
    categorySlug: 'exclusive',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20year%20review%20concept%20with%20film%20strip%20showing%20multiple%20scenes%2C%20warm%20golden%20retro%20lighting%2C%20editorial%20magazine%20layout%20style%2C%20clean%20background%2C%20nostalgic%20cinematic%20mood&width=800&height=1000&seq=feat-3-e5f2&orientation=portrait',
    date: '2026-07-01',
    tags: ['盘点', '名场面', '2026'],
    viewCount: 456789,
    commentCount: 15678,
  },
];

export const dailyCompetitionArticles = [
  {
    id: '8',
    slug: 'meiri-dasai-diliuqi-huigu',
    title: '每日大赛第六期回顾：神仙打架，评委都看傻了',
    excerpt: '第六期每日大赛堪称神仙打架，各位选手使出浑身解数，评委席一片寂静。',
    category: '每日大赛',
    categorySlug: 'daily-competition',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20competition%20stage%20performance%20with%20dancer%20in%20dramatic%20pose%2C%20spotlight%20beam%2C%20warm%20golden%20stage%20lighting%2C%20editorial%20performance%20photography%2C%20clean%20dark%20background%2C%20cinematic%20drama&width=600&height=400&seq=daily-1-m7n3&orientation=landscape',
    date: '2026-07-03',
    tags: ['每日大赛', '神仙打架'],
    viewCount: 123456,
    commentCount: 5432,
  },
  {
    id: '9',
    slug: 'meiri-dasai-diwuqi-jieguo',
    title: '每日大赛第五期结果出炉，冠军竟然是他',
    excerpt: '第五期每日大赛投票结果正式公布，黑马选手以微弱优势夺冠。',
    category: '每日大赛',
    categorySlug: 'daily-competition',
    imageUrl: 'https://readdy.ai/api/search-image?query=Competition%20winner%20announcement%20moment%20with%20trophy%20and%20confetti%2C%20dramatic%20golden%20hour%20lighting%2C%20editorial%20sports%20photography%20style%2C%20clean%20background%2C%20celebration%20mood&width=600&height=400&seq=daily-2-q4r8&orientation=landscape',
    date: '2026-07-02',
    tags: ['每日大赛', '冠军', '黑马'],
    viewCount: 98765,
    commentCount: 3456,
  },
  {
    id: '10',
    slug: 'meiri-dasai-disiqi-jingxuan',
    title: '每日大赛第四期精选片段，全程高能',
    excerpt: '第四期每日大赛精彩片段集锦，全程高能无尿点，错过直播的快来看。',
    category: '每日大赛',
    categorySlug: 'daily-competition',
    imageUrl: 'https://readdy.ai/api/search-image?query=Highlights%20montage%20of%20performance%20show%20with%20dynamic%20motion%20blur%2C%20warm%20stage%20lighting%20with%20coral%20accents%2C%20editorial%20entertainment%20photography%2C%20clean%20dark%20backdrop%2C%20exciting%20atmosphere&width=600&height=400&seq=daily-3-t9u5&orientation=landscape',
    date: '2026-07-01',
    tags: ['每日大赛', '精选', '高能'],
    viewCount: 87654,
    commentCount: 2345,
  },
  {
    id: '11',
    slug: 'meiri-dasai-disanqi-toujiao',
    title: '每日大赛第三期：选手互投环节火药味十足',
    excerpt: '第三期选手互投环节火药味十足，两位热门选手正面交锋，场面一度失控。',
    category: '每日大赛',
    categorySlug: 'daily-competition',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20face-off%20between%20two%20performers%20on%20stage%2C%20dramatic%20split%20lighting%2C%20warm%20amber%20and%20coral%20tones%2C%20editorial%20photography%2C%20clean%20background%2C%20competitive%20tension&width=600&height=400&seq=daily-4-v1w6&orientation=landscape',
    date: '2026-06-30',
    tags: ['每日大赛', '冲突', '火药味'],
    viewCount: 76543,
    commentCount: 2345,
  },
];

export const starScandalArticles = [
  {
    id: '12',
    slug: 'li-mou-nanyixing-bei-qianze',
    title: '李某男星被前女友发文谴责，聊天记录曝光',
    excerpt: '前女友深夜发文控诉某知名男星李某，多张聊天记录截图引发全网热议。',
    category: '明星塌房',
    categorySlug: 'star-scandal',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cryptic%20social%20media%20post%20on%20phone%20screen%20with%20dramatic%20shadows%2C%20moody%20night%20lighting%2C%20warm%20brown%20tones%2C%20editorial%20news%20style%2C%20clean%20dark%20background%2C%20mysterious%20atmosphere&width=600&height=400&seq=star-1-b2x9&orientation=landscape',
    date: '2026-07-05',
    tags: ['李某', '前女友', '聊天记录'],
    viewCount: 456789,
    commentCount: 23456,
  },
  {
    id: '13',
    slug: 'wang-mou-nvxing-dapian',
    title: '王某女星被爆片场耍大牌，工作人员集体吐槽',
    excerpt: '多位剧组工作人员匿名爆料某王姓女星在片场的种种过分行为。',
    category: '明星塌房',
    categorySlug: 'star-scandal',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20director%20chair%20and%20empty%20set%2C%20dramatic%20shadows%20and%20harsh%20lighting%2C%20warm%20brown%20tones%2C%20editorial%20documentary%20style%2C%20clean%20minimal%20composition&width=600&height=400&seq=star-2-d3y1&orientation=landscape',
    date: '2026-07-04',
    tags: ['耍大牌', '片场', '爆料'],
    viewCount: 345678,
    commentCount: 15678,
  },
  {
    id: '14',
    slug: 'chen-mou-hunyin-weiji',
    title: '陈某夫妇婚姻危机？知情人士：已分居半年',
    excerpt: '娱乐圈模范夫妻陈某夫妇被爆婚姻出现危机，据称已分居超过半年。',
    category: '明星塌房',
    categorySlug: 'star-scandal',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cracked%20wedding%20ring%20symbolism%20on%20dark%20surface%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20warm%20amber%20mood%2C%20editorial%20concept%20photography%2C%20clean%20background%2C%20emotional%20tension&width=600&height=400&seq=star-3-f4z2&orientation=landscape',
    date: '2026-07-03',
    tags: ['婚姻危机', '分居', '模范夫妻'],
    viewCount: 567890,
    commentCount: 34567,
  },
];

export const influencerArticles = [
  {
    id: '15',
    slug: 'wanghong-dage-bang-jiami',
    title: '网红大葛被爆直播间数据造假，粉丝怒了',
    excerpt: '知名带货网红大葛直播间被质疑数据造假，真实观看人数不足宣称的十分之一。',
    category: '网红反差',
    categorySlug: 'influencer-drama',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20ring%20light%20and%20empty%20chair%2C%20dramatic%20lighting%20contrast%2C%20warm%20coral%20accents%2C%20editorial%20documentary%20style%2C%20clean%20background%2C%20deceptive%20mood&width=600&height=400&seq=inf-1-g5a3&orientation=landscape',
    date: '2026-07-05',
    tags: ['直播', '数据造假', '带货'],
    viewCount: 234567,
    commentCount: 8765,
  },
  {
    id: '16',
    slug: 'meishizhubo-jiameng-neimu',
    title: '美食主播假吃内幕：镜头前的每一口都是表演',
    excerpt: '前MCN工作人员揭露美食主播假吃产业链，镜头前狼吞虎咽，镜头后全是套路。',
    category: '网红反差',
    categorySlug: 'influencer-drama',
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20content%20creation%20setup%20with%20camera%20and%20empty%20plate%2C%20dramatic%20reveal%20lighting%2C%20warm%20brown%20and%20amber%20tones%2C%20editorial%20photography%2C%20clean%20minimal%20background%2C%20behind%20the%20scenes&width=600&height=400&seq=inf-2-h6b4&orientation=landscape',
    date: '2026-07-04',
    tags: ['美食主播', '假吃', 'MCN'],
    viewCount: 198765,
    commentCount: 7654,
  },
  {
    id: '17',
    slug: 'duan-shipin-wanghong-renshe-beng',
    title: '短视频网红阿强人设崩塌全过程回顾',
    excerpt: '从爆火到翻车，细数短视频网红阿强人设崩塌的完整时间线。',
    category: '网红反差',
    categorySlug: 'influencer-drama',
    imageUrl: 'https://readdy.ai/api/search-image?query=Falling%20domino%20pieces%20symbolizing%20reputation%20collapse%2C%20dramatic%20sequential%20lighting%2C%20warm%20coral%20tones%2C%20editorial%20concept%20photography%2C%20clean%20background%2C%20downward%20trajectory&width=600&height=400&seq=inf-3-j7c5&orientation=landscape',
    date: '2026-07-03',
    tags: ['人设崩塌', '短视频', '时间线'],
    viewCount: 312456,
    commentCount: 12345,
  },
];

export const exclusiveArticles = [
  {
    id: '18',
    slug: 'neimu-renyuan-baoliao-jingji-gongsi',
    title: '内部人员独家爆料：三大经纪公司暗箱操作实录',
    excerpt: '多位经纪公司离职员工联合爆料，揭示娱乐圈资源分配的暗箱操作内幕。',
    category: '独家爆料',
    categorySlug: 'exclusive',
    imageUrl: 'https://readdy.ai/api/search-image?query=Confidential%20documents%20with%20red%20stamp%20on%20dark%20desk%2C%20dramatic%20shadow%20play%2C%20warm%20brown%20tones%2C%20editorial%20investigative%20journalism%20style%2C%20clean%20minimal%20background&width=600&height=400&seq=exc-1-k8d6&orientation=landscape',
    date: '2026-07-05',
    tags: ['经纪公司', '暗箱操作', '独家'],
    viewCount: 456789,
    commentCount: 23456,
  },
  {
    id: '19',
    slug: 'yulequan-qian-guize-jiexi',
    title: '娱乐圈潜规则深度解析：新人不得不面对的残酷现实',
    excerpt: '深度调查娱乐圈新人面临的潜规则，多位业内人士匿名分享真实经历。',
    category: '独家爆料',
    categorySlug: 'exclusive',
    imageUrl: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20person%20standing%20at%20crossroads%20with%20multiple%20paths%2C%20dramatic%20lighting%20from%20above%2C%20warm%20amber%20tones%2C%20editorial%20concept%20photography%2C%20clean%20background%2C%20contemplative%20mood&width=600&height=400&seq=exc-2-l9e7&orientation=landscape',
    date: '2026-07-04',
    tags: ['潜规则', '新人', '深度调查'],
    viewCount: 345678,
    commentCount: 18901,
  },
];

export const allArticles = [
  ...hotTopics,
  ...featureArticles,
  ...dailyCompetitionArticles,
  ...starScandalArticles,
  ...influencerArticles,
  ...exclusiveArticles,
];

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-global-line' },
  { name: '明星塌房', slug: 'star-scandal', icon: 'ri-alert-line' },
  { name: '网红反差', slug: 'influencer-drama', icon: 'ri-contrast-2-line' },
  { name: '每日大赛', slug: 'daily-competition', icon: 'ri-live-line' },
  { name: '独家爆料', slug: 'exclusive', icon: 'ri-spy-line' },
];

export const articleContentMap: Record<string, { content: string; author: string }> = {
  'ding-yuxi-bei-bao-shui-jun': {
    author: '吃瓜小编',
    content: `<p>近日，一则关于知名演员丁禹兮团队涉嫌购买水军刷数据的爆料在网络上迅速发酵，引发网友广泛关注和讨论。</p>
<p>据一位自称曾在某数据营销公司工作的匿名爆料人透露，丁禹兮团队在过去一年中，通过第三方渠道大量购买水军服务，用于微博超话签到、热搜话题刷榜以及作品评分操控等行为。爆料人还提供了多张疑似交易记录的截图，其中包含了具体的服务项目和金额信息。</p>
<h2>工作室火速回应</h2>
<p>面对舆论压力，丁禹兮工作室于7月5日凌晨紧急发布声明，坚决否认了所有关于购买水军的指控。声明中称："所有关于丁禹兮先生购买水军的不实言论均为恶意造谣，工作室已委托律师团队收集证据，将依法追究造谣者的法律责任。"</p>
<p>然而，网友对此声明的反应褒贬不一。有粉丝表示坚决支持偶像，认为这是竞争对手的恶意抹黑；也有网友指出，声明中并未正面回应截图中的具体交易细节，显得避重就轻。</p>
<h2>业内人士分析</h2>
<p>一位不愿透露姓名的娱乐圈数据分析师表示，明星购买水军在业内早已是公开的秘密，但近年来随着平台监管趋严，此类行为一旦被曝光，对艺人形象的影响将比以往更为严重。该分析师同时指出，如果爆料属实，丁禹兮可能面临平台限流甚至更严重的处罚。</p>
<h2>事件持续发酵</h2>
<p>截至目前，该话题在微博的阅读量已突破5亿，讨论量超过200万。多个相关话题登上热搜榜，网友们的讨论热度持续高涨。本报将持续关注此事的后续发展。</p>`,
  },
  'wanghong-xiaomei-fancha-shipin': {
    author: '吃瓜小编',
    content: `<p>以"清纯甜美"形象走红的短视频网红小美，近日因一段私下聚会视频的流出而陷入巨大争议。</p>
<p>视频中，小美的言行举止与其在短视频平台上一贯展示的"乖乖女"形象大相径庭——粗口连篇、行为举止极为张扬，让众多粉丝大跌眼镜。这段视频在网络上迅速传播后，#小美反差# 话题短时间内登上热搜榜前列。</p>
<h2>粉丝反应两极分化</h2>
<p>事件曝光后，小美的粉丝群体出现了明显的分裂。一部分"老粉"表示极度失望，认为长期以来被欺骗了感情，纷纷取关并删除相关支持内容。另一部分粉丝则认为"每个人都有私下的一面"，不应该用镜头前的标准来要求博主的全部生活。</p>
<h2>MCN机构紧急公关</h2>
<p>据悉，小美所在的MCN机构已紧急启动危机公关程序。有消息人士透露，该机构正在考虑让小美发布道歉视频，试图挽回形象。但同时也有业内人士分析，对于"反差"类网红来说，这次事件或许反而能带来一波流量红利。</p>
<h2>反差网红现象反思</h2>
<p>此次事件也引发了公众对"反差网红"这一现象的深入讨论。所谓的"反差"，本质上是网红经济中人设运营的一种策略，但当人设与真实差距过大时，必然面临"翻车"风险。业内人士呼吁，网红行业需要回归真实，过度包装的人设终将面临崩溃。</p>`,
  },
};

export const aboutData = {
  brandIntro: '吃瓜网成立于2024年，是国内领先的娱乐八卦资讯平台。我们致力于为用户提供最快、最全、最真实的娱乐圈动态和独家爆料。从明星塌房到网红反差，从每日大赛到独家内幕，吃瓜网始终站在娱乐资讯的最前沿。',
  mission: '我们的使命是打破信息壁垒，让每一个吃瓜群众都能第一时间获取真实、有趣的娱乐资讯。我们坚持客观公正的报道原则，拒绝虚假信息和恶意炒作。',
  teamIntro: '吃瓜网拥有一支经验丰富的娱乐新闻采编团队，成员来自各大主流媒体和娱乐平台。我们的记者遍布全国各地，7×24小时不间断追踪娱乐圈的最新动态。',
  credibility: [
    { label: '7×24小时', value: '全天候追踪', description: '我们的编辑团队全天候不间断工作，确保任何时段的重大娱乐事件都能在第一时间被报道。' },
    { label: '200+', value: '独家爆料', description: '自成立以来，我们已经为读者带来了超过200条行业独家爆料，其中多条被主流媒体转载引用。' },
    { label: '500万+', value: '月活跃用户', description: '凭借优质的内容和快速的报道，吃瓜网已经积累了超过500万的月活跃用户群体。' },
  ],
  values: [
    { title: '真实', description: '我们坚持报道真实信息，杜绝一切虚假新闻和恶意炒作。每一条爆料都经过严格的核实流程。' },
    { title: '快速', description: '7×24小时全天候追踪娱乐圈动态，确保读者第一时间获取最新资讯。' },
    { title: '独家', description: '拥有广泛的线人网络和行业资源，持续产出独家深度内容。' },
  ],
  contact: {
    email: 'tips@chiguawang.com',
    wechat: 'chiguawang666',
    weibo: '@吃瓜网官方',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
  },
};

export const faqData = [
  { question: '吃瓜网的内容来源是什么？', answer: '吃瓜网的内容来自多个渠道，包括：自有采编团队的原创报道、行业线人提供的独家爆料、合作媒体的内容转载以及用户投稿。所有信息在发布前都会经过编辑团队的审核和核实，确保内容的真实性和可靠性。' },
  { question: '如何向吃瓜网提供爆料线索？', answer: '您可以通过以下方式向我们提供爆料线索：发送邮件至 tips@chiguawang.com，或添加官方微信 chiguawang666。我们承诺对所有爆料人的身份信息严格保密，并对有价值的线索提供相应报酬。' },
  { question: '吃瓜网会删除已发布的文章吗？', answer: '吃瓜网尊重事实和真相。如果已发布的内容被证实存在事实性错误，我们会在第一时间进行更正并发布更正声明。如果内容涉及当事人合法权益且符合相关法律规定，我们也会依法进行处理。' },
  { question: '如何在吃瓜网上投稿？', answer: '目前吃瓜网的投稿功能正在开发中。如果您有优质的娱乐八卦内容想要分享，可以通过邮件将稿件发送至 tips@chiguawang.com，我们的编辑团队会在3个工作日内进行审核和回复。' },
  { question: '吃瓜网的更新频率是怎样的？', answer: '吃瓜网实行7×24小时不间断更新机制。我们的编辑团队全天候轮值，确保无论白天黑夜，只要有重大娱乐事件发生，您都能在吃瓜网上第一时间看到相关报道。' },
];